<div class="dialogContainer" [ngClass]="{'visible': showDialog}">
  <div class="dialog">
    @if (message) {
      <div class="message" [innerHTML]="message | safeHtml"></div>
    }
    <div class="dialogButtonsContainer">
      @switch (dialogType) {
        @case ('confirmCancel') {
          <button class="button no-margin-bottom" (click)="confirm()">Confirm</button>
          <button class="button no-margin-bottom" id="focusme" (click)="cancel()">Cancel</button>
        }
        @case ('continueCancel') {
          <button class="button no-margin-bottom" (click)="confirm()">Continue</button>
          <button class="button no-margin-bottom" id="focusme" (click)="cancel()">Cancel</button>
        }
        @case ('yesNo') {
          <button class="button no-margin-bottom" (click)="confirm()">Yes</button>
          <button class="button no-margin-bottom" id="focusme" (click)="cancel()">No</button>
        }
        @case ('ok') {
          <button class="button no-margin-bottom" id="focusme" (click)="confirm()">OK</button>
        }
        @case ('exit') {
          <button class="button no-margin-bottom" id="focusme" (click)="confirm()">Exit</button>
        }
      }
    </div>
  </div>
</div>
